import { useEffect, useState } from 'react'
import useIsOnline from '@/services/useIsOnline'
import { Button } from '@/UIComponents2/Button'
import CrossIcon from '@/CustomIcons/CrossIcon'
import InfoTriangleIcon from '@/CustomIcons/InfoTriangleIcon'

function IsOfflineBanner() {
    const _isOnline = useIsOnline()
    const [show, set_show] = useState<boolean>(false)
    const [isForceClosed, set_isForceClosed] = useState<boolean>(false)

    useEffect(() => {
        if (!_isOnline) {
            setTimeout(() => {
                set_show(!_isOnline)
            }, 3000)
        } else {
            set_show(false)
        }
    }, [_isOnline])

    useEffect(() => {
        if (show) {
            set_isForceClosed(false)
        }
    }, [show])

    const containerClass =
        'absolute bottom-0 flex justify-center items-center w-full h-[40px] bg-[#F9CC04] z-[100] px-4'

    if (!show || isForceClosed) {
        return null
    }

    return (
        <div className={containerClass}>
            <div className="flex items-center justify-center gap-2 w-full text-center text-black">
                <InfoTriangleIcon /> No network connection
            </div>
            <Button variant="basic" onClick={() => set_isForceClosed(true)}>
                <CrossIcon color="#333" />
            </Button>
        </div>
    )
}

export default IsOfflineBanner
